const SHELDON_PREFIXES = ["PO", "FR", "AG", "G", "VG", "F", "VF", "XF", "AU", "MS", "PF", "PR", "SP", "SMS"];

export const extractSheldonPrefix = (gradeText) => {
  const normalized = String(gradeText || "").trim().toUpperCase();
  if (!normalized) return null;
  const match = normalized.match(/^([A-Z]{1,3})\s*[- ]?\s*(\d{1,2})/);
  if (!match) return null;
  const prefix = match[1];
  return SHELDON_PREFIXES.includes(prefix) ? prefix : null;
};
